import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#222",
      d: "M9 1.5C4.86 1.5 1.5 4.86 1.5 9s3.36 7.5 7.5 7.5 7.5-3.36 7.5-7.5S13.14 1.5 9 1.5M9 15c-3.307 0-6-2.693-6-6s2.693-6 6-6 6 2.693 6 6-2.693 6-6 6m.232-6.645c-1.327-.338-1.754-.705-1.754-1.253 0-.63.592-1.072 1.575-1.072 1.034 0 1.424.495 1.454 1.23h1.283c-.037-1.005-.652-1.928-1.867-2.227V3.75H8.175v1.268c-1.133.24-2.04.974-2.04 2.107 0 1.342 1.118 2.018 2.745 2.408 1.462.345 1.755.862 1.755 1.402 0 .397-.293 1.042-1.575 1.042-1.2 0-1.673-.54-1.74-1.23H6.03c.075 1.276 1.02 1.995 2.145 2.228v1.275H9.93v-1.252c1.14-.218 2.04-.87 2.047-2.078-.007-1.65-1.424-2.22-2.745-2.565"
    }, null, -1)
  ]))]))
}
export default { render: render }